import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const DocInDocIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        style={customStyle}
        height={size}
        fill="none"
        viewBox="0 0 20 23"
      >
        <path
          fill="currentColor"
          d="M.842 19.942c0 1.908.984 2.892 2.865 2.892h8.227c1.88 0 2.865-.993 2.865-2.892v-1.626h1.494c1.88 0 2.865-.993 2.865-2.891V8.473c0-1.16-.246-1.899-.94-2.61L13.84 1.396c-.668-.676-1.46-.94-2.47-.94H8.066c-1.88 0-2.865.993-2.865 2.9v1.618H3.707c-1.88 0-2.865 1.002-2.865 2.9zm13.07-9.246L9.146 5.862c-.668-.676-1.239-.861-2.197-.879v-1.52c0-.8.422-1.248 1.266-1.248h3.665V6.39c0 1.09.58 1.66 1.661 1.66H17.4v7.26c0 .81-.421 1.257-1.265 1.257h-1.336v-3.375c0-1.186-.15-1.74-.888-2.496m-.58-4.526V2.927L16.942 6.6h-3.181c-.308 0-.43-.123-.43-.431M2.59 19.828V7.99c0-.808.422-1.257 1.274-1.257h2.68v4.782c0 1.274.625 1.89 1.89 1.89h4.615v6.424c0 .809-.422 1.257-1.275 1.257H3.856c-.843 0-1.265-.448-1.265-1.257m6.012-7.963c-.36 0-.519-.15-.519-.518v-4.28l4.729 4.798z"
        ></path>
      </svg>
    </div>
  );
};

export default DocInDocIcon;
